import { CHECKOUT_ERRORS } from 'tradera-helpers/checkout-errors';
import { webApiClient } from 'tradera-utils/http';
import {
    axiosWithTokenRefresh,
    axiosConfigs,
    finalizeResponse,
    handleError
} from 'tradera-utils/api';

const setErrorMessage = e => {
    if (e) {
        // eslint-disable-next-line better-mutation/no-mutation
        e.message = e.response?.data?.responseStatus?.errorCode;
        throw e;
    } else {
        throw new Error(CHECKOUT_ERRORS.GENERIC);
    }
};

export const getCheckout = async purchaseOrderId =>
    webApiClient.get(
        `/shopping/ordercheckout/purchaseordercheckoutviewmodel/${purchaseOrderId}`,
        {
            withCredentials: true
        }
    );

export const getPaymentOptions = async (purchaseOrderId, selectedShippingId) =>
    webApiClient.get(
        `/shopping/ordercheckout/purchaseorderpaymentoptions/${purchaseOrderId}`,
        {
            params: {
                selectedShippingId
            },
            withCredentials: true
        }
    );

export const initializePayment = async formData =>
    webApiClient
        .post(
            '/shopping/ordercheckout/initializepurchaseorderpaymentattempt',
            formData
        )
        .catch(e => {
            setErrorMessage(e);
        });

export const getPaymentStatus = async paymentAttemptId =>
    webApiClient.get(
        `/shopping/ordercheckout/purchaseorderpaymentattemptstatus/${paymentAttemptId}`
    );

export const completePayment = async formData =>
    webApiClient.post(
        '/shopping/ordercheckout/completepurchaseorderpaymentattempt',
        formData
    );

export const purchaseBin = async formData =>
    webApiClient.post('/shopping/ordercheckout/purchasebin', formData);

export const getBraintreeToken = async (purchaseOrderId, paymentOption) =>
    webApiClient.get(
        `/shopping/ordercheckout/purchaseorderbraintreeclienttoken/${purchaseOrderId}`,
        {
            params: {
                paymentMethod: paymentOption
            },
            withCredentials: true
        }
    );

export const getExternalAuthData = async paymentAttemptId =>
    webApiClient.get(
        `/shopping/ordercheckout/purchaseorderpaymentattemptauthenticationdata/${paymentAttemptId}`
    );

export const sendSwishSms = async formData =>
    axiosWithTokenRefresh()
        .post(
            '/shopping/swishapp2app/send',
            formData,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());

export const requestCombinedShippingPrice = async formData =>
    webApiClient.post(
        '/shopping/ordercheckout/requestcombinedshippingprice',
        formData
    );

export const setShippingInfo = async formData =>
    webApiClient.post('/shopping/ordercheckout/setshippinginfo', formData);

export const setCollectionPoint = async formData =>
    webApiClient.post('/shopping/ordercheckout/setcollectionpoint', formData);

export const cancelPayment = async formData =>
    webApiClient.post(
        '/shopping/ordercheckout/cancelpurchaseorderpaymentattempt',
        formData
    );

export const getCollectionPoints = async (
    countryCodeIso2,
    shippingProvider,
    zipCode
) => {
    const params = new URLSearchParams({
        countryCodeIso2,
        shippingProvider,
        zipCode
    });

    return webApiClient.get(
        `${'/selling/collection-points-unifaun'}?${params.toString()}`,
        axiosConfigs.authenticated
    );
};

export const createKlarnaClientToken = async (
    purchaseOrderId,
    orderCalculation
) =>
    webApiClient.post(
        '/shopping/ordercheckout/createpurchaseorderklarnaclienttoken',
        {
            purchaseOrderId,
            orderCalculation
        }
    );

// Export object for Sinon stubbing
export default {
    getBraintreeToken,
    getCheckout,
    getExternalAuthData,
    getPaymentOptions,
    initializePayment,
    getPaymentStatus,
    completePayment,
    sendSwishSms,
    requestCombinedShippingPrice,
    cancelPayment,
    setShippingInfo,
    setCollectionPoint,
    getCollectionPoints,
    createKlarnaClientToken
};
